<template>
  <div v-if="hotDestinations.length > 0" data-testid="hot-destinations-view">
    <HotDestinationsGrid :cities="hotDestinations" />
  </div>
</template>

<script>
import HotDestinationsGrid from './HotDestinationsGrid.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('offersDestinations')
export default {
  name: 'HotDestinations',
  components: {
    HotDestinationsGrid
  },
  computed: {
    ...mapGetters(['hotDestinations'])
  }
}
</script>
